<template>
  <CHeader
    class="mt-0 mb-4"
    with-subheader
    light
  >
    <CToggler
      in-header
      class=" d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class=" d-md-down-none"
    />
    <!-- @click="$store.commit('toggleSidebarDesktop')" -->
    <CHeaderBrand
      class="mx-0 d-lg-none"
      to="/home"
    >
      <CIcon
        name="logo"
        height="25"
        alt="Logo"
      />
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <!-- <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard">
          Dashboard
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/users" exact>
          Users
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink>
          Settings
        </CHeaderNavLink>
      </CHeaderNavItem>-->
    </CHeaderNav>

    <CHeaderNav class="mr-4">
      <NotificacoesUsuarios
        v-if="getTipo != 'PE' && getTipo != 'MT'"
        class="mr-2"
      />

      <TheHeaderDropdownAccnt class="mr-n3" />
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0" />
    </CSubheader>
    <div>
      <CModal
        title="Deseja sair do sistema ?"
        variant="warning"
        color="warning"
        :centered="true"
        :show.sync="warningModal"
      >
        Ao sair notificações não serão entregues
        <div slot="footer">
          <CRow>
            <CCol cols="1">
              <CButton
                color="primary"
                @click="warningModal = false"
              >Cancelar</CButton>
            </CCol>
            <CCol cols="1">
              <CButton
                color="success"
                @click="logout()"
              >Sair</CButton>
            </CCol>
          </CRow>
        </div>
      </CModal>
    </div>
  </CHeader>
</template>

<script>
import NotificacoesUsuarios from "./NotificacoesUsuarios.vue";
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

export default {
  name: "TheHeader",
  data() {
    return {
      warningModal: false,
    };
  },
  components: {
    NotificacoesUsuarios,
    TheHeaderDropdownAccnt,
  },
  computed: {
    getTipo() {
      return this.$store.getters.getTipo;
    },
  },
  methods: {
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
    logout() {
      this.close_websocket();
      this.$store.commit("DESTROY_USER");
      this.$router.push("/");
      // this.$forceUpdate();
    },
    close_websocket() {
      // this.$socket.close();

              this.$socket.client.emit("vue_disconect");

    },
  },
};
</script>
